export const Mutation = {
  SET_RESERVATION_INFO: "SET_RESERVATION_INFO",
};
